import { useMemo } from 'react';
import { useLocation } from 'react-router';

type BaseRouteState = {
  from?: string;
};

export type RouteStateReader<TState extends object = object> = Readonly<{
  current: Readonly<BaseRouteState & TState>;
}>;

function isObject(value: unknown): value is object {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function useUrlStateReader<TState extends object = object>(): RouteStateReader<TState> {
  const location = useLocation();

  return useMemo(
    () => ({
      current: Object.freeze(isObject(location.state) ? location.state : {}) as Readonly<
        BaseRouteState & TState
      >,
    }),
    [location.state]
  );
}
